import Image from "next/image";
import Link from "next/link";
import DarkMode from "../mode/DarkMode";
import Logo from "./../../public/images/logo.png";
import WhiteLogo from "./../../public/images/logo_white.png";
import SeiLogo from "./../../public/sei.png";
import PhantomLogo from "./../../public/phantom.png";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "next/router";
import { isChildrenPageActive } from "../../utils/daynamicNavigation";
import { useEffect, useState } from "react";
import WalletButton from "../wallet-btn/WalletButton";
import {
  useCosmWasmClient,
  useSigningCosmWasmClient,
  useWallet as useSeiWallet,
  WalletSelectModal,
  useSelectWallet,
} from "@sei-js/react";
import { PublicKey } from "@solana/web3.js";
import { web3 } from "@project-serum/anchor";

import { useWallet as usePhantomWallet } from "@solana/wallet-adapter-react";
import { useWalletModal } from "@solana/wallet-adapter-react-ui";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineSwapHoriz } from "react-icons/md";

import { cartBuyHandle } from "../../api/index";
import { cartBuy, getAllCollection } from "../../utils/api";
import {
  updateCart,
  updateSeiPrice,
  updateSeiWallet,
  updateCollectionList,
} from "../../redux/marketplaceSlice";
import ConnectButton from "../ConnectButton";
import { SOLANA_DECIMAL, SOLANA_RPC } from "../../config";

const DECIMAL = 1000000;

export default function Header() {
  const [toggle, setToggle] = useState(false);
  const [isCollapse, setCollapse] = useState(null);
  const {
    connectedWallet: connectedSei,
    accounts,
    disconnect: disconnectSei,
  } = useSeiWallet();
  const {
    publicKey,
    disconnect: disconnectPhantom,
    connected: connectedPhantom,
  } = usePhantomWallet();
  const { setVisible } = useWalletModal();
  const { openModal } = useSelectWallet();

  const { cosmWasmClient: queryClient } = useCosmWasmClient();
  const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();
  const [balance, setBalance] = useState(0);
  const [switchNetworkState, SetSwitchNetworkState] = useState(false);
  const [solBalance, setSolBalance] = useState(0);
  const [cartModal, setCartModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [cartTotalSei, setCartTotalSei] = useState();
  const [collectionData, setCollectionData] = useState([]);
  const dispatch = useDispatch();

  const { cart, collectionList } = useSelector((state) => state.marketplace);
  const getBalance = async () => {
    if (queryClient) {
      const balance = await queryClient?.getBalance(
        accounts[0].address,
        "usei"
      );
      setBalance((balance.amount / DECIMAL).toFixed(3));
    }
  };

  const getSolBalance = async () => {
    const solConnection = new web3.Connection(SOLANA_RPC);

    if (publicKey) {
      const publicKeyObj = new PublicKey(publicKey.toBase58());
      const balance = await solConnection.getBalance(publicKeyObj);
      setSolBalance(balance / SOLANA_DECIMAL);
    } else {
      console.log("Wallet Not Connected");
    }
  };

  useEffect(() => {
    if (publicKey) {
      getSolBalance();
    }
  }, [publicKey]);

  // useEffect(() => {
  //   if (collectionList?.length >= collectionData.length)
  //     setCollectionData(collectionList);
  // }, [collectionList]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    let input = e.target.value.toLowerCase();
    console.log("search: ", input, collectionList);
    const results = collectionList.filter((item) => {
      return (
        item.name.toLowerCase().includes(input) ||
        item.contract.toLowerCase() === input
      );
    });
    if (input !== "" && results.length > 0) {
      console.log(results);
      setCollectionData(results);
    }
  };

  // useEffect(() => {
  //   try {
  //     const data = fetch(
  //       "https://api.coingecko.com/api/v3/simple/price?ids=sei-network&vs_currencies=USD"
  //     );
  //     dispatch(updateSeiPrice(data["sei-network"]["usd"]));
  //     return data.json();
  //   } catch (error) {
  //     console.log("error");
  //   }
  // }, []);

  useEffect(() => {
    if (accounts.length > 0) {
      dispatch(updateSeiWallet(accounts[0]?.address));
      getBalance();
    }
  }, [accounts, queryClient]);

  // window resize
  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1024) {
        setToggle(false);
      }
    });
  });

  const route = useRouter();

  const mobileCollapse = (id) => {
    if (isCollapse === id) {
      return setCollapse(null);
    }
    setCollapse(id);
  };

  const buyHandle = async () => {
    if (!connectedWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 3000,
      });
    }
    console.log("cart: ", cart);
    if (cart.length <= 0) {
      return toast.warning("Empty Cart", {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 3000,
      });
    }

    let id = toast.loading("Buying...", {
      position: toast.POSITION.BOTTOM_LEFT,
      autoClose: 3000,
    });

    const res = await cartBuyHandle(signingClient, accounts[0].address, cart);
    if (res.success) {
      await cartBuy(cart);
      dispatch(updateCart({ cart: [] }));
      toast.update(id, {
        render: "Bought successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
    } else {
      toast.update(id, {
        render: "Got Error",
        type: "warning",
        autoClose: 2000,
        isLoading: false,
      });
    }
  };

  const removeCartHandle = async (item) => {
    const temp = [...cart];
    const result = [];
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].id != item.id) result.push(temp[i]);
    }
    dispatch(updateCart({ cart: result }));
    toast.success("Successfully removed", {
      position: toast.POSITION.BOTTOM_LEFT,
      autoClose: 3000,
    });
  };

  //Wallet Switch Function
  const handleSwitchNetwork = () => {
    if (!connectedPhantom) {
      setVisible(true);
      dispatch(updateSeiWallet(null));
      disconnectSei();
      route.pathname.split("/")[1] === "user" &&
        route.push("/soluser/avatar_2");
    } else {
      openModal();
      disconnectPhantom();
      route.pathname.split("/")[1] === "soluser" && route.push("/user/avatar");
    }
  };

  useEffect(() => {
    const total = 0;
    for (let i = 0; i < cart.length; i++) {
      total += Number(cart[i].price);
    }
    setCartTotalSei(total);
  }, [cart]);

  useEffect(() => {
    const interval = setInterval(() => {
      getAllCollection(0).then((data) => {
        dispatch(updateCollectionList(data));
      });
    }, 10000); // 10000 milliseconds = 10 second
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getAllCollection(0).then((data) => {
      dispatch(updateCollectionList(data));
    });
  }, []);

  return (
    <>
      {/* main desktop menu sart*/}
      <header className="js-page-header fixed top-0 z-20 w-full backdrop-blur bg-jacarta-800 border-b-[1px] border-jacarta-400">
        <div className="flex items-center px-6 py-4 xl:px-24 ">
          <WalletSelectModal />
          <Link className="shrink-0" href="/">
            <a>
              <div className="dark:hidden">
                <Image
                  src={Logo}
                  height={60}
                  width={190}
                  alt="Nut Market"
                  className="max-h-7 h-auto "
                />
              </div>
              <div className="hidden dark:block">
                <Image
                  src={WhiteLogo}
                  height={30}
                  width={170}
                  alt="Nut Market"
                />
              </div>
            </a>
          </Link>
          {/* End  logo */}

          <form
            action="search"
            className="relative ml-12 mr-8 hidden basis-3/12 lg:block xl:ml-[8%]"
          >
            <input
              type="search"
              className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-[0.6875rem] px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
              placeholder="Search"
              onChange={handleSearch}
            />
            <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="fill-jacarta-500 h-4 w-4 dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
              </svg>
            </span>
            {/* ======search start======= */}
            {searchTerm && (
              <div
                className="modal-content absolute w-full"
                style={{ right: -20 }}
              >
                <div className="modal-body p-1">
                  <div className="accordion" id="accordionProps">
                    <div className="accordion-item dark:border-jacarta-600 border-jacarta-100 border-b">
                      <div className="flex flex-col gap-2.5 mt-3">
                        {collectionData.map((item, index) => (
                          <div
                            onClick={() => {
                              window.location.href = `/collection/${item.contract}`;
                            }}
                            key={item.id}
                            className=" w-full"
                          >
                            <div className="flex justify-between align-items text-center items-center px-2 cursor-pointer">
                              <div className="flex justify-center align-items text-center items-center px-2 mt-3">
                                <img
                                  src={item.image_url}
                                  width={30}
                                  height={30}
                                  className="mr-2 rounded-md"
                                />
                                <span>{item?.name}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <div className="flex items-center justify-center w-full "></div>
                </div>
              </div>
            )}

            {/* ============= */}
          </form>

          {/* End Desktop search form */}

          <div className="js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent">
            <nav className="navbar w-full">
              <ul className="flex flex-col lg:flex-row items-center justify-center">
                {/* Home */}
                {/* <li className="group">
                  <Link href="/">
                    <a>
                      <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(route.asPath, "/")
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Home
                        </span>
                      </button>
                    </a>
                  </Link>
                </li> */}

                {/* marketplace */}
                {/* <li className="group">
                  <Link href="/marketplace">
                    <a>
                      <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(route.asPath, "/marketplace")
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Marketplace
                        </span>
                      </button>
                    </a>
                  </Link>
                </li> */}

                {/* collection */}
                <li className="group">
                  <Link href="/collection/explore_collection">
                    <a>
                      <button className="text-white font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(
                              route.asPath,
                              "/collection/explore_collection"
                            )
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Collection
                        </span>
                      </button>
                    </a>
                  </Link>
                </li>

                {/* Activity */}
                <li className="group">
                  <Link href="/activity">
                    <a>
                      <button className="text-white font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(route.asPath, "/activity")
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Activity
                        </span>
                      </button>
                    </a>
                  </Link>
                </li>

                <li className="group" onClick={() => setToggle(false)}>
                  <Link href="/create">
                    <a>
                      <button className="text-white font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive("/create", route.asPath)
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Create
                        </span>
                      </button>
                    </a>
                  </Link>
                </li>

                <li className="group">
                  <button
                    className="relative text-white font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5"
                    onClick={() => setCartModal(true)}
                  >
                    {/* <span className={"text-accent dark:text-accent"}>Cart</span> */}
                    {cart.length > 0 ? (
                      <span className="absolute inline-flex items-center justify-center w-7 h-7 text-xs font-bold text-white bg-red border-1 border-white rounded-full -top-2 right-1 dark:border-gray-900">
                        {cart.length}
                      </span>
                    ) : null}

                    <Image
                      src="/cart_icon.png"
                      alt="cart"
                      width={35}
                      height={35}
                    />
                  </button>
                </li>
              </ul>
            </nav>
            {/* End menu for desktop */}

            <div className="ml-3 hidden items-center lg:flex">
              <div className="hidden md:block">
                {!connectedSei && !connectedPhantom ? <WalletButton /> : null}
                {/* <ConnectButton /> */}
              </div>

              {/* End metamask Wallet */}
              {connectedSei || connectedPhantom ? (
                <div className="js-nav-dropdown group-dropdown relative">
                  <button className="dropdown-toggle border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width={24}
                      height={24}
                      className="fill-jacarta-700 h-6 w-6 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                    </svg>
                  </button>
                  <div className="dropdown-menu dark:bg-jacarta-800 group-dropdown-hover:opacity-100 group-dropdown-hover:visible !-right-4 !top-[85%] !left-auto z-10 min-w-[14rem] whitespace-nowrap rounded-xl bg-white transition-all will-change-transform before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-2 lg:px-1 lg:shadow-2xl hidden lg:invisible lg:opacity-0">
                    <div>
                      <button className="js-copy-clipboard font-display text-jacarta-700 my-4 flex select-none items-center whitespace-nowrap px-5 leading-none dark:text-white">
                        Account :
                        <span className="text-gray-500 text-[#9c9c9c] ml-2">
                          {" "}
                          {!connectedPhantom
                            ? accounts[0].address?.slice(0, 4)
                            : publicKey.toBase58().slice(0, 4)}
                          {`... `}
                          {!connectedPhantom
                            ? accounts[0].address?.slice(-4)
                            : publicKey.toBase58().slice(-4)}
                        </span>
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width={24}
                          height={24}
                          className="ml-1 dark:fill-jacarta-300 fill-jacarta-500 mb-px h-4 w-4"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 0 1 2 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zM4.003 9L4 20h11V9H4.003z" />
                        </svg> */}
                      </button>
                    </div>
                    <div className="dark:border-jacarta-600 border-jacarta-100 mx-5 mb-6 rounded-lg border p-2 ">
                      <span className="dark:text-jacarta-200 text-text-[15px] font-medium tracking-tight">
                        Balance :
                      </span>
                      <div className="flex items-center gap-3 mt-2">
                        {!connectedPhantom ? (
                          <Image
                            src={SeiLogo}
                            height={28}
                            width={28}
                            alt="SEI"
                            className="max-h-7 h-auto rounded-full"
                          />
                        ) : (
                          <Image
                            src={PhantomLogo}
                            height={28}
                            width={28}
                            alt="SEI"
                            className="max-h-7 h-auto rounded-full"
                          />
                        )}

                        <span className="text-green text-lg font-bold">
                          {!connectedPhantom ? balance : solBalance.toFixed(2)}{" "}
                          {!connectedPhantom ? "SEI" : "SOL"}
                        </span>
                      </div>
                    </div>
                    <button
                      className="dark:hover:bg-jacarta-600  focus:text-accent hover:bg-jacarta-50 flex items-center space-x-1 rounded-xl px-5 py-2 transition-colors"
                      onClick={() => handleSwitchNetwork()}
                    >
                      <MdOutlineSwapHoriz size={20} />
                      <span className="font-display text-jacarta-700 mt-1 text-[15px] dark:text-white">
                        Switch to{" "}
                        {!connectedPhantom ? "Phantom Wallet" : "Sei Wallet"}
                      </span>
                    </button>

                    <Link
                      href={
                        connectedPhantom
                          ? "/soluser/avatar_2/"
                          : "/user/avatar/"
                      }
                    >
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width={24}
                          height={24}
                          className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                        </svg>
                        <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                          My Profile
                        </span>
                      </a>
                    </Link>

                    {/*<Link href="/profile/avatar">
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width={24}
                          height={24}
                          className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M9.954 2.21a9.99 9.99 0 0 1 4.091-.002A3.993 3.993 0 0 0 16 5.07a3.993 3.993 0 0 0 3.457.261A9.99 9.99 0 0 1 21.5 8.876 3.993 3.993 0 0 0 20 12c0 1.264.586 2.391 1.502 3.124a10.043 10.043 0 0 1-2.046 3.543 3.993 3.993 0 0 0-3.456.261 3.993 3.993 0 0 0-1.954 2.86 9.99 9.99 0 0 1-4.091.004A3.993 3.993 0 0 0 8 18.927a3.993 3.993 0 0 0-3.457-.26A9.99 9.99 0 0 1 2.5 15.121 3.993 3.993 0 0 0 4 11.999a3.993 3.993 0 0 0-1.502-3.124 10.043 10.043 0 0 1 2.046-3.543A3.993 3.993 0 0 0 8 5.071a3.993 3.993 0 0 0 1.954-2.86zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                        </svg>
                        <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                          Edit Profile
                        </span>
                      </a>
                    </Link>*/}
                    <button
                      onClick={() => {
                        disconnectPhantom();
                        disconnectSei();
                      }}
                    >
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width={24}
                          height={24}
                          className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11V8l-5 4 5 4v-3h8v-2H7z" />
                        </svg>
                        <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                          Sign out
                        </span>
                      </a>
                    </button>
                  </div>
                </div>
              ) : null}
              {/* <DarkMode /> */}
            </div>
            {/* End header right content (metamask and other) for desktop */}
          </div>
          {/* header menu conent end for desktop */}

          <div className="ml-auto flex lg:hidden">
            <Link
              href={connectedPhantom ? "/soluser/avatar_2/" : "/user/avatar/"}
            >
              {!connectedSei && !connectedPhantom ? (
                ""
              ) : (
                <a
                  className="border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
                  aria-label="profile"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                  </svg>
                </a>
              )}
            </Link>
            {/* <DarkMode /> */}
            <button
              className="js-mobile-toggle border-jacarta-100 hover:bg-accent dark:hover:bg-accent focus:bg-accent group ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
              aria-label="open mobile menu"
              onClick={() => setToggle(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z" />
              </svg>
            </button>
          </div>
          {/* End header right content  for mobile */}
        </div>
        {/* End flex item */}
      </header>
      {/* main desktop menu end */}

      {/* start mobile menu and it's other materials  */}
      <div
        className={`lg:hidden js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-20 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent ${
          toggle ? "nav-menu--is-open" : "hidden"
        }`}
      >
        <div className="t-0 dark:bg-jacarta-800 fixed left-0 z-10 flex w-full items-center justify-between bg-white p-6 lg:hidden">
          <div className="dark:hidden">
            <Image
              src={Logo}
              height={28}
              width={130}
              alt="Nut Market"
              className="max-h-7 h-auto "
            />
          </div>

          <div className="hidden dark:block">
            <Image src={WhiteLogo} height={28} width={130} alt="Nut Market" />
          </div>

          <button
            className="js-mobile-close border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
            onClick={() => setToggle(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
            </svg>
          </button>
        </div>
        {/* mobile menu top header content */}

        <form action="search" className="relative mt-24 mb-8 w-full lg:hidden">
          <input
            type="search"
            className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-3 px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
            placeholder="Search"
          />
          <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              className="fill-jacarta-500 h-4 w-4 dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
            </svg>
          </span>
        </form>
        {/* End search form mobile menu  */}

        <nav className="navbar w-full">
          <ul className="flex flex-col lg:flex-row">
            {/* =========== */}
            {/* <li className="group" onClick={() => setToggle(false)}>
              <Link href="/activity">
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/activity", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      Marketplace
                    </span>
                  </button>
                </a>
              </Link>
            </li> */}
            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/collection/explore_collection">
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/create", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      Collection
                    </span>
                  </button>
                </a>
              </Link>
            </li>

            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/activity">
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/activity", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      Activity
                    </span>
                  </button>
                </a>
              </Link>
            </li>
            <li className="group" onClick={() => setToggle(false)}>
              <Link
                href={connectedPhantom ? "/soluser/avatar_2/" : "/user/avatar/"}
              >
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/activity", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      My Profile
                    </span>
                  </button>
                </a>
              </Link>
            </li>
            <button
              onClick={() => {
                disconnectPhantom();
                disconnectSei();
                dispatch(updateSeiWallet(null));
              }}
              className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5"
            >
              <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                Sign out
              </span>
            </button>
            <button
              className="dark:hover:bg-jacarta-600  focus:text-accent hover:bg-jacarta-50 flex items-center space-x-1 rounded-xl py-2 transition-colors"
              onClick={() => handleSwitchNetwork()}
            >
              <MdOutlineSwapHoriz size={20} />
              <span className="font-display text-jacarta-700 mt-1 text-[15px] dark:text-white">
                Switch to {!connectedPhantom ? "Phantom" : "Sei"}
              </span>
            </button>
            {/* =========== */}
          </ul>
        </nav>
        {/* End navbar mobile menu  */}

        {/* mt-10 w-full lg:hidden */}

        {/* <!-- Cart Modal --> */}

        {/* <!-- end properties modal --> */}
      </div>
      {/* End mobile menu and it's other materials */}
      <div
        className={cartModal ? "modal fade show block" : "modal fade"}
        id="cartModal"
        onClick={(e) => {
          if (e.target.id == "cartModal") setCartModal(false);
        }}
      >
        <div className="modal-dialog w-full m-0" style={{ height: "100vh" }}>
          <div
            className="modal-content absolute"
            style={{ right: -20, height: "calc(100vh - 61px)" }}
          >
            <div className="modal-header flex flex-col">
              <div className="flex justify-between w-full">
                <h5 className="modal-title" id="propertiesModalLabel">
                  Your Cart
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setCartModal(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                  </svg>
                </button>
              </div>
              <div className="flex justify-between w-full">
                <div>Items</div>
                <div>
                  <button
                    type="button"
                    onClick={() => dispatch(updateCart({ cart: [] }))}
                  >
                    Clear all
                  </button>
                </div>
              </div>
            </div>

            {/* <!-- Body --> */}
            <div className="modal-body p-1">
              <div className="accordion" id="accordionProps">
                <div className="accordion-item dark:border-jacarta-600 border-jacarta-100 border-b">
                  <div className="px-4 py-2">
                    <span className="font-bold	"> Buy Now </span>
                  </div>
                  <div className="flex flex-col gap-2.5">
                    {cart.map((item, index) => (
                      <div
                        key={index}
                        className="flex justify-between align-items text-center items-center px-2"
                      >
                        <div className="flex justify-center align-items text-center items-center px-2">
                          <img
                            src={item.image}
                            width={60}
                            height={60}
                            className="mr-2 rounded-md"
                          />
                          <span>{item?.title}</span>
                        </div>

                        <div>
                          <div>
                            <button
                              type="button"
                              onClick={() => {
                                removeCartHandle(item);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                              >
                                <path fill="none" d="M0 0h24v24H0z"></path>
                                <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                              </svg>
                            </button>
                          </div>
                          <div>{(item?.price / DECIMAL).toFixed(3)} SEI</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- end body --> */}

            <div className="modal-footer">
              <div className="w-full flex items-center justify-between space-x-4 py-2">
                <div>
                  <span className="font-bold	"> Total: </span>
                </div>
                <div>
                  <span className="font-bold	">
                    {" "}
                    {(cartTotalSei / DECIMAL).toFixed(3)} SEI{" "}
                  </span>
                </div>
              </div>
              <div className="flex items-center justify-center w-full ">
                <button
                  type="button"
                  onClick={() => buyHandle()}
                  className="bg-accent shadow-accent-volume hover:bg-accent-dark w-full rounded-full py-3 text-center font-semibold text-white transition-all"
                  style={{ minWidth: "300px" }}
                >
                  Buy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
